import { ProjectHeaderNavProps } from "./ProjectHeaderNav";
import { EuiCollapsibleNavBeta } from "@inscopix/ideas-eui";
import { getTableMenuItems } from "./ProjectHeaderNav.helpers";
import { useRouteMapContext } from "providers/RouteMapProvider/RouteMapProvider";

type ProjectHeaderNavProjectProps = Pick<
  ProjectHeaderNavProps,
  "project" | "currentTenant" | "folders" | "tables" | "selectedTableId"
>;

export const ProjectHeaderNavProject = ({
  project,
  currentTenant,
  folders,
  tables,
  selectedTableId,
}: ProjectHeaderNavProjectProps) => {
  const navigateToTable = useRouteMapContext(
    (s) => (tableKey: string) =>
      s.routeMap["PROJECT_TABLE"]
        .dynamicPath({
          projectKey: project.key,
          tableKey,
          tenantKey: currentTenant.key,
        })
        .navigateTo(),
  );
  const tableMenuItems = getTableMenuItems(
    tables,
    folders,
    selectedTableId,
    navigateToTable,
  );

  return (
    <EuiCollapsibleNavBeta.Item
      title={project.name}
      icon="tableDensityExpanded"
      isCollapsible={false}
      items={[
        {
          title: "Tables",
          isCollapsible: true,
          accordionProps: {
            initialIsOpen: true,
          },

          items: tableMenuItems,
        },
      ]}
    />
  );
};
